import * as React from "react";
import AuthService from '../../../services/authService';
import UserService from "../../../services/userService";
import { NotificationSchedulerModel } from '../../../models/notificationSchedulerModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Spinner from '../../../common/components/spinner/spinner';
import Growl from '../../../common/components/alertMessage/growl';
import Translate from "../../../common/functions/translate";
import logo01white from "../../../assets/images/logos/Logo-01-icon.png";
import { connect } from 'react-redux';
import AcceptanceDialog from './userNotificationAcceptanceDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faCalendar, faChevronRight, faCheckSquare, faUserClock, faClock } from '@fortawesome/free-solid-svg-icons';

interface IProps {
    lang: string;
}

interface IState {
    notifications: Array<NotificationSchedulerModel>;
    isLoading: boolean;
    first: number;
    rows: number;
    totalRecords: number;
    acceptanceShow: boolean;
    selectedId: number;
}

class UserNotificationList extends React.Component<IProps, IState> {
    userService = new UserService();
    authService = new AuthService();
    growl: any;
    intervalId: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            notifications: new Array<NotificationSchedulerModel>(),
            isLoading: false,
            first: 0,
            rows: 20,
            totalRecords: 0,
            acceptanceShow: false,
            selectedId: 0
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }


    onScroll = () => {
        let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
        if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
            this.state.totalRecords > this.state.notifications.length && !this.state.isLoading) {
            this.paginatorClick({ first: this.state.first + this.state.rows }, false);
        }
    };

    paginatorClick = (e, isInit: boolean) => {
        this.setState({ first: e.first }, () => this.getNotifications(isInit));
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        this.getNotifications(true);
    }

    openDialog = (m: NotificationSchedulerModel, event) => {
        event.preventDefault();
        this.setState({ selectedId: m.notificationSchedulerId, acceptanceShow: true });
    }

    closeDialog = () => {
        this.setState({ acceptanceShow: false, first: 0 }, () => this.getNotifications(true));
    }

    getNotifications = (isInit: boolean) => {
        this.setState({
            isLoading: true
        });

        if (this.authService.isAuthenticated()) {
            this.userService.getAllNotifications(this.state.first, this.state.rows, this.props.lang).then(
                (data: any) => {
                    if (data) {
                        if (isInit) {
                            this.setState({
                                isLoading: false,
                                totalRecords: data.totalRecords,
                                notifications: [...data.notifications]
                            });
                        }
                        else {
                            this.setState({
                                isLoading: false,
                                notifications: [...this.state.notifications, ...data.notifications],
                                totalRecords: data.totalRecords
                            });
                        }
                    }
                })
                .catch(error => {
                    this.setState({
                        isLoading: false
                    });
                    this.growl.show({ severity: 'error', summary: error.message });
                });
        }
    }

    render() {
        const { notifications, isLoading, acceptanceShow, selectedId } = this.state;

        return (
            <>
                <div className="app-content">
                    <Growl ref={(el) => this.growl = el} />
                    <h2>{Translate('Notifications')}</h2>
                    <ul className="list-items">
                        {notifications && notifications.length > 0 ?
                            notifications.map((m: NotificationSchedulerModel) =>
                                <li key={m.notificationSchedulerId + 'Scheduler-list'} onClick={(e) => this.openDialog(m, e)}>
                                    <div className="item-action">
                                        <img src={logo01white} className="app-logo" alt="logo" style={{ marginRight: 15 }} />
                                    </div>
                                    <div className="item-info" style={{ width: 'calc(100% - 120px)' }}>
                                        <div className="item-name">
                                            {m.userId == this.authService.getUserId() ? Translate("You have to take medicines at") :
                                                m.userName + ' ' + Translate("have to take his/hers medicines at")}
                                            {" " + HelperFunctions.fomatTimeAsStringWithoutSeconds(new Date(m.nextExecutionDate))
                                                + " " + Translate("oclock on date") + " " + HelperFunctions.fomatDatesStringWithLang(new Date(m.nextExecutionDate), this.props.lang)}
                                        </div>
                                        <div className="item-desc">
                                            {m.medicineName ? m.medicineName : null}
                                        </div>
                                        {m.takenAt ?
                                            <div className="item-desc" style={{ color: '#04b5e0' }}>
                                                <FontAwesomeIcon icon={faCheckSquare} />
                                                <span> {Translate('taken at')} {HelperFunctions.fomatDateTimeAsStringWithLang(new Date(m.takenAt), this.props.lang)}</span>
                                            </div>
                                            :
                                            m.isSnoozed === true ?
                                                <div className="item-desc">
                                                    <FontAwesomeIcon icon={faClock} />
                                                    <span>  {Translate('snoozed for') + " " + HelperFunctions.fomatDateTimeAsStringWithLang(new Date(m.executedAt), this.props.lang)}</span>
                                                </div>
                                                :
                                                <div className="item-desc" style={{ color: 'red' }}>
                                                    {m.takenAt ? null : Translate('No Intake')}
                                                </div>
                                        }
                                    </div>
                                    <div className="item-actions" style={{ paddingLeft: 3 }}>
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </div>
                                </li>
                            ) : null}
                    </ul>
                    {isLoading ? <Spinner inlineSpinner={true} /> : null}
                    {!isLoading && (!notifications || notifications.length == 0) ? Translate("No records found") : null}
                </div>
                {acceptanceShow ?
                    <AcceptanceDialog
                        isVisible={acceptanceShow}
                        handleCancelButton={this.closeDialog}
                        handleSaveButton={this.closeDialog}
                        notifiicationSchedulerId={selectedId}>
                    </AcceptanceDialog>
                    : null}
            </>
        )
    }
}

const mapsStateToProps = state => {
    return {
        lang: state.common.lang
    };
}

export default connect(mapsStateToProps)(UserNotificationList);